<script setup lang="ts">
import ModalBase from '@/components/modal/modal-container.vue'
import ModalTitle from '@/components/modal/modal-title.vue'
import ModalContent from '@/components/modal/modal-content.vue'
import ModalFooterCancelAndSave from '@/components/modal/modal-footer-cancel-and-save.vue'
import GridContainer from '@/components/grid-container.vue'
import GridItem from '@/components/grid-item.vue'
import InputLabel from '@/components/input-label.vue'
import InputSelect from '@/components/input-select.vue'
import InputDate from '@/components/input-date.vue'
import { useWheelingAssets } from '@/composables/assets/assets'
import { ref, computed } from 'vue'
import IconHelp from '@/shared/components/IconHelp.vue'
import ContentLoader from '@/components/content-loader.vue'
import HeroSplashError from '@/components/hero-splash-error.vue'

const emit = defineEmits<{
    close: []
    submit: [{assetCode: string, invoiceDate: Date}]
}>()

const { data: assets, isFetching: isFetchingAssets, isError: assetsHasError} = useWheelingAssets()

const assetSearch = ref('')
const selectedAsset = ref<string | null>(null)
const invoiceDate = ref<Date>()

const assetList = computed(() => {
    if(!assets.value)
        return []

    const items = assets.value?.items ?? []

    return items.map(x => ({
        assetCode: x.assetCode,
        display: `${x.name} (Project: ${x.projectCode} | Asset: ${x.assetCode}) | ${x.type}`
    }))
})

function onCancel(){
    emit('close')
}

async function onSave(){
    emit('submit', { assetCode: selectedAsset.value!, invoiceDate: invoiceDate.value!})
}

</script>
<template>
    <ModalBase>
        <ModalTitle>WHICH ASSET ARE YOU INVOICING?</ModalTitle>
        <ModalContent>
            <ContentLoader :loading="isFetchingAssets" variant="overlay">
                <HeroSplashError v-if="assetsHasError"/>                
                <GridContainer :columns="['1fr','3fr']">
                    <GridItem>
                        <InputLabel>Asset</InputLabel>
                    </GridItem>
                    <GridItem>
                        <InputSelect :items="assetList" 
                        item-value="assetCode"
                        item-text="display"
                        searchable
                        :placeholder="isFetchingAssets ? `Loading.....` : undefined"
                        v-model:selected="selectedAsset"
                        v-model:search="assetSearch"
                        :disabled="isFetchingAssets"
                        :required="true"
                        error-variant="tooltip"/>
                    </GridItem>
                    <GridItem>
                        <InputLabel>Invoice Date</InputLabel>
                        <IconHelp class="ms-1" :tooltip="`The invoice is the invoice date, and will be reflected as such on the invoice.`" />
                    </GridItem>
                    <GridItem>
                        <InputDate v-model:value="invoiceDate" :required="true" error-variant="tooltip"/>
                    </GridItem>
                </GridContainer>
            </ContentLoader>
        </ModalContent>
        <ModalFooterCancelAndSave
         :class="$style['footer']"
         :pending="isFetchingAssets"
         :enabled="!isFetchingAssets && !assetsHasError"
         @cancel="onCancel"
         @save="onSave"
        />
    </ModalBase>
</template>
<style module>
.footer{
    margin-top:12px;
}
</style>